import store, { hydrateFromStorage } from "@/redux/store";
import useFilterStore from "@/stores/useFilterStore";
import useUserStore from "@/stores/useUserStore";
import { refreshCustomerQueryCache } from "@/services/queryClient";

const GLOBAL_STATE_STORAGE_KEY = "GLOBAL_STATE";

function normalizeCustomerId(customerId) {
	if (customerId == null || customerId === "") {
		return null;
	}

	return Number(customerId);
}

function readCustomerIdFromAuth() {
	const authUser = store.getState().auth?.user;
	return normalizeCustomerId(authUser?.customer?.id ?? authUser?.customer_id);
}

function readCustomerIdFromUserStore() {
	return normalizeCustomerId(useUserStore.getState().user?.customer_id);
}

function resolveCustomerId() {
	return readCustomerIdFromAuth() ?? readCustomerIdFromUserStore();
}

function syncUserFromReduxAuth() {
	const authUser = store.getState().auth?.user;
	if (authUser) {
		useUserStore.getState().setUserFromAuth(authUser);
	}
}

function handleCustomerContextChange(previousCustomerId) {
	const nextCustomerId = resolveCustomerId();

	if (previousCustomerId != null && nextCustomerId != null && previousCustomerId !== nextCustomerId) {
		refreshCustomerQueryCache();
	}

	return nextCustomerId;
}

function handleStorageEvent(event, customerIdRef) {
	if (!event.key) {
		return;
	}

	if (event.key === GLOBAL_STATE_STORAGE_KEY) {
		if (event.newValue) {
			hydrateFromStorage(event.newValue);
			syncUserFromReduxAuth();
			customerIdRef.current = handleCustomerContextChange(customerIdRef.current);
		}
		return;
	}

	if (event.key === "agroinventario-filter-storage") {
		useFilterStore.persist.rehydrate();
		return;
	}

	if (event.key === "agroinventario-user-storage") {
		useUserStore.persist.rehydrate();
		customerIdRef.current = handleCustomerContextChange(customerIdRef.current);
	}
}

export function setupCrossTabSync() {
	const customerIdRef = { current: resolveCustomerId() };

	const onStorage = (event) => handleStorageEvent(event, customerIdRef);

	window.addEventListener("storage", onStorage);

	return () => {
		window.removeEventListener("storage", onStorage);
	};
}
